module.exports = __webpack_public_path__ + "images/liinilaevad/ms-icon-310x150.png";